import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TesteCanaisContatoComponent } from './teste-canais-contato.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    TesteCanaisContatoComponent
  ],
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    LocalizeRouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    TesteCanaisContatoComponent
  ]
})

export class TesteCanaisContatoModule { }
